import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

const DetailsListDivider = ({ className })=>jsx("hr", {
        className: classNames('mt-6', 'border-neutral', className)
    });
DetailsListDivider.displayName = 'DetailsList.Divider';

export { DetailsListDivider, DetailsListDivider as default };
//# sourceMappingURL=DetailsList.Divider.es.js.map
